import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Stack, IconButton } from '@mui/material';

// project import
import DrawerHeaderStyled from './DrawerHeaderStyled';

// ==============================|| DRAWER HEADER ||============================== //

const DrawerHeader = ({ open }) => {
	const theme = useTheme();

	return (
		<DrawerHeaderStyled theme={theme} open={open}>
			<Stack className="header-logo" direction="row" spacing={1} alignItems="center">
				<IconButton
					component={Link}
					to="/"
					disableRipple
					sx={{
						color: 'brandDark.contrastText',
						width: 'auto',
						height: 'auto',
						padding: 0,
						display: 'flex',
						flexDirection: 'row',
						gap: '8px',
						alignItems: 'center',
						'&:hover': { color: 'secondary.lighter' },
					}}
				>
					<img src="/images/logo-light.png" alt="LynOrg" height={28} />
				</IconButton>
			</Stack>
		</DrawerHeaderStyled>
	);
};

DrawerHeader.propTypes = {
	open: PropTypes.bool,
};

export default DrawerHeader;
